module.exports = __webpack_public_path__ + "img/gif2.8fa4a622.svg";